import { render, staticRenderFns } from "./scopecenter2.vue?vue&type=template&id=7a63a466&scoped=true"
import script from "./scopecenter2.vue?vue&type=script&lang=js"
export * from "./scopecenter2.vue?vue&type=script&lang=js"
import style0 from "./scopecenter2.vue?vue&type=style&index=0&id=7a63a466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a63a466",
  null
  
)

export default component.exports